import Vue from 'vue'
import GlobTopNav from './../../components/globTopNav'
import ProductItem from './../../components/productItem'

Vue.component('GlobTopNav', GlobTopNav)
Vue.component('ProductItem', ProductItem)


// WEBPACK FOOTER //
// ./src/assets/js/components.js